import * as types from "../actions/actionTypes";
import SourceType from "../constants/sourceType";

const initialState = {
  is_fetched: false,
  loading: true,
  data: [],
  last_item: "",
  inProcess: {},
  errorInProcess: {},
  status:"",
  source_id: "",
  source_type: SourceType.FUND,
  source:{}
};

const Cheque = (state = initialState, action) => {
  let loadings = { ...state.inProcess };
  let errors = { ...state.errorInProcess };
  switch (action.type) {
    case types.CHANGE_CHEQUE_STATUE_REQUEST:
      errors[action.chequeId] = null;
      loadings[action.chequeId] = true;
      return { ...state, inProcess: loadings, errorInProcess: errors };
    case types.CHANGE_CHEQUE_STATUE_SUCCESS:
      errors[action.payLoad.cheque_data.data.cheque.id] = false;
      loadings[action.payLoad.cheque_data.data.cheque.id] = false;
      return { ...state, inProcess: loadings, errorInProcess: errors, status: action.payLoad.cheque_data.data.cheque.status };
    case types.CHANGE_CHEQUE_STATUE_FAILURE:
      errors[action.chequeId] = true;
      loadings[action.chequeId] = false;
      return { ...state, inProcess: loadings, errorInProcess: errors };
    case types.GET_CHEQUE_LIST_REQUEST:
      return { ...state, loading: true };
    case types.GET_CHEQUE_LIST_SUCCESS:
      return {
        ...state,
        data: action.payLoad,
        loading: false,
        is_fetched: true
      };
    case types.GET_CHEQUE_LIST_FAILURE:
      return { ...state, loading: false };
    case types.CHANGE_CHEQUE_SOURCE_TYPE:
      return { ...state, source_type: action.payLoad };
    case types.CHANGE_CHEQUE_SOURCE_ID:
      return { ...state, source_id: action.payLoad };
    case types.CHANGE_CHEQUE_SOURCE_INFO:
      return {
        ...state,
        source: action.payLoad.source
      };
    default:
      return state;
  }
};

export default Cheque;
